import { RootState } from 'app/store';
import { FC } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { closeModal, confirmModal, selectModal } from './modalSlice';
import BaseModal from 'common/components/modal/base-modal';
import { ButtonTheme } from 'common/components/buttons/button-theme';

export const Modal: FC = () => {
  const dispatch = useDispatch();
  const {
    modalInfo: { modalProps },
    isOpen,
    isLoading
  } = useSelector((state: RootState) => selectModal(state));

  const title = modalProps?.title ?? 'Modal Title';
  const content = modalProps?.content ?? 'Modal Content';
  const confirmButtonText = modalProps?.confirmButtonText ?? 'Delete';
  const cancelButtonText = modalProps?.cancelButtonText ?? 'Cancel';

  const triggerClick = () => {
    dispatch(
      confirmModal({
        title: modalProps.title,
        additionalProps: modalProps.additionalProps
      })
    );
  };

  return (
    <>
      {isOpen ? (
        <BaseModal
          title={title}
          onConfirm={() => triggerClick()}
          onCancel={() => dispatch(closeModal())}
          confirmButtonText={confirmButtonText}
          cancelButtonText={cancelButtonText}
          confirmButtonTheme={
            modalProps?.confirmButtonTheme ?? ButtonTheme.PRIMARY
          }
          cancelButtonTheme={
            modalProps?.cancelButtonTheme ?? ButtonTheme.CANCEL
          }
          isLoading={isLoading}
        >
          <div className="text-gray-700">{content}</div>
        </BaseModal>
      ) : null}
    </>
  );
};
